import { takeEvery, put, call, all } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import { acInquiryActionTypes } from '../actions/actionTypes';
import { exportErrorMsg, processError, renderFileName } from '../../../../common/util';
import invokeApi from '../../../../common/apiManagement/invokeApi';
import { getAction } from '../../../../../stateManagement/reduxUtil';
import {
  processingStarted,
  processingCompleted,
} from '../../../../common/redux/actions/commonActions';
import moduleAPI from '../../config/apiConfig';
import { globalConstants } from '../../../../common/moduleConstants';

// task inquiry
export function* getAccountingInquiryExportList(action) {
  yield all([
    put(processingStarted()),
    put(getAction(acInquiryActionTypes.RESET_SERVER_VALUE, null)),
  ]);
  let resetServerValue = null;
  try {
    const responseData = yield call(
      invokeApi,
      moduleAPI.ACCOUNTING_INQUIRY_EXPORT,
      action.data,
    );
    const filename = renderFileName(responseData);
    const urlData = window.URL.createObjectURL(new Blob([responseData.data]));
    FileSaver(urlData, filename);
    yield put(processingCompleted());
  } catch (err) {
    if (err.response.status === globalConstants.errorCode402 || err.response.status === globalConstants.errorCode403) {
      const errorObject = exportErrorMsg(err.response.status);
      resetServerValue = { serverRequestError: errorObject };
    } else {
      resetServerValue = { serverRequestError: processError(err) };
    }
    yield all([
      put(getAction(acInquiryActionTypes.RESET_SERVER_VALUE, resetServerValue)),
      put(processingCompleted()),
    ]);
  }
}

export function* getAccountingInquiryList(action) {
  yield all([
    put(processingStarted()),
    put(getAction(acInquiryActionTypes.RESET_SERVER_VALUE, null)),
    put(getAction(acInquiryActionTypes.LOG_ACINQ_LIST_REQUEST, action.data)),
  ]);
  let resetServerValue = { serverRequestError: null };
  try {
    const responseData = yield call(invokeApi, moduleAPI.ACCOUNTING_INQUIRY_LIST, action.data);
    yield all([
      put(getAction(acInquiryActionTypes.GET_ACINQ_LIST_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    resetServerValue = { serverRequestError: processError(err) };
    yield all([
      put(getAction(acInquiryActionTypes.RESET_SERVER_VALUE, resetServerValue)),
      put(getAction(acInquiryActionTypes.GET_ACINQ_LIST_ERROR, err)),
      put(processingCompleted()),
    ]);
  }
}
function* accountingInquiryWatcher() {
  yield takeEvery(acInquiryActionTypes.GET_ACINQ_LIST_REQUEST, getAccountingInquiryList);
  yield takeEvery(acInquiryActionTypes.GET_ACINQ_EXPORT_REQUEST, getAccountingInquiryExportList);
}

export default accountingInquiryWatcher;
